export const errorCodes = Object.freeze({
  errorCodes: {
    UNEXPECTED_EXCEPTION: 1
  }
});
